<script setup lang="ts">
</script>

<script lang="ts">
import {defineComponent, PropType} from "vue";
import store from "@/store";

export default defineComponent({
    name: 'ToolTipWrapper',

    data(): {
        isHovered: boolean
        timeout: number | null
    } {
        return {
            isHovered: false,
            timeout: null,
        }
    },

    props: {
        asClass: {
            type: null as unknown as PropType<string | null>,
            required: false,
            default: 'section',
        },

        display: {
            type: null as unknown as PropType<string>,
            required: false,
            default: null,
        },

        timeoutDuration: {
            type: Number,
            required: false,
            default: 0,
        },

        followsCursor: {
            type: Boolean,
            required: false,
            default: true,
        },

        offset: {
            type: Number,
            required: false,
            default: 35,
        },

        cursor: {
            type: String,
            required: false,
            default: 'help',
        },

        tooltipWithWrapper: {
            type: Boolean,
            required: false,
            default: true,
        },

        classes: {
            type: [Array, null],
            required: false,
            default: null,
        },

        isActive: {
            type: Boolean,
            required: false,
            default: true,
        },
    },

    computed: {
        tooltipStyle(): {[key: string]: string}
        {
            return this.followsCursor
                ? this.getStyleWhenCursorFollowingEnabled()
                : this.getStyleWhenCursorFollowingDisabled()
        }
    },

    methods: {
        getStyleWhenCursorFollowingEnabled(): {[key: string]: string}
        {
            const style: {[property: string]: string} = {}

            const x: number = store.state.cursor.x
            const y: number = store.state.cursor.y

            const width: number = window.innerWidth
            const height: number = window.innerHeight

            if (x <= width / 2 + 250) {
                style.left = `${x + this.offset}px`
                style.right = `auto`
            } else {
                style.left = `auto`
                style.right = `${width - x + this.offset}px`
            }

            if (y <= height / 2 + 250) {
                style.bottom = `auto`
                style.top = `${y + this.offset}px`
            } else {
                style.bottom = `${height - y + this.offset}px`
                style.top = `auto`
            }

            return style
        },

        getStyleWhenCursorFollowingDisabled(): {[key: string]: string}
        {
            return {}
        },

        start(): void
        {
            if (!this.isActive) {
                return
            }

            this.timeout = setTimeout(() => {
                this.isHovered = true
            }, this.timeoutDuration)
        },

        stop(): void
        {
            if (this.timeout) {
                clearTimeout(this.timeout)
            }

            this.isHovered = false
        },
    },
})
</script>

<template>
    <component
        :is="asClass"
        class="wrapper"
        :ref="`component`"
        :style="{
            display: display || 'auto',
            cursor: cursor,
        }"
        :class="classes || []"

        @mouseenter="start"
        @mouseleave="stop"
    >
        <slot
            class="component"
            name="component"
        />

        <Teleport
            to="body"
            v-if="isHovered"
        >
            <div
                class="tooltipWrapper"
                data-bs-theme="dark"
                :class="{
                    withWrapper: tooltipWithWrapper,
                }"
                :style="tooltipStyle"
                @mousemove="stop"
            >
                <slot name="tooltip"/>
            </div>
        </Teleport>
    </component>
</template>

<style scoped lang="scss">
.wrapper {
    //width: fit-content;
}

.tooltipWrapper {
    display: flex;
    position: fixed;
    justify-content: center;
    align-items: center;
    font-size: 12px;
    font-family: Storopia, serif;
    border-radius: 4px;
    z-index: 99999;
    color: gray;

    &.withWrapper {
        background: rgba(0, 0, 0, 0.6);
        backdrop-filter: blur(10px);
        padding: 3px 10px 3px 10px;
        box-shadow: 0 0 5px 1px black;
    }
}
</style>
